import styled from '@emotion/styled';
import { useGetUserBonusCardsQuery } from '@features/freespin/api/freespinApi';
import usableCards from '@features/my-freebets/usableCards';
import { useFetchBaseBetsQuery } from '@features/user-bets/api/userBetsApi';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

const StyledMenu = styled(Box)`
  padding: 8px 10px 12px;
  text-align: center;

  .my-freebets-title {
    margin-bottom: 8px;
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
  }

  .my-freebets-pills {
    display: flex;
    justify-content: center;
  }

  .my-freebets-pill {
    display: flex;
    align-items: center;
    height: 30px;
    border: 1px solid #000;
    border-radius: 15px;
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
    text-transform: uppercase;
  }

  .my-freebets-pill-label {
    padding: 0 8px;
  }

  .my-freebets-active .my-freebets-pill-label {
    padding-right: 20px;
  }

  .my-freebets-history .my-freebets-pill-label {
    padding-left: 12px;
  }

  .my-freebets-count {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    height: 30px;
    margin: -1px;
    padding: 0 4px;
    border: 1px solid #000;
    border-radius: 15px;
  }

  .my-freebets-active,
  .my-freebets-active .my-freebets-count {
    color: #fff;
    background-color: ${props => props.theme.palette.success.main};
  }

  .my-freebets-history,
  .my-freebets-history .my-freebets-count {
    color: #000;
    background-color: ${props => props.theme.palette.warning.main};
  }

  .my-freebets-history {
    margin-left: -12px;
  }
`;

export default function MyFreebetsMenu() {
  const { data: cards, isSuccess: cardsLoaded } = useGetUserBonusCardsQuery(undefined, { refetchOnMountOrArgChange: true });
  const { data: history, isSuccess: historyLoaded } = useFetchBaseBetsQuery({ page: 1, limit: 1, freebet: true }, { refetchOnMountOrArgChange: true });
  const activeCount = cardsLoaded ? usableCards(cards)?.length ?? 0 : '';
  const historyCount = historyLoaded ? history?.pagination?.total_items ?? 0 : '';

  return (
    <StyledMenu className="my-freebets-menu">
      <Typography className="my-freebets-title">
        <FormattedMessage id="MY_FREEBETS_TITLE"/>
      </Typography>
      <Box className="my-freebets-pills">
        <Link to="/my-freebets" className="my-freebets-pill my-freebets-active">
          <span className="my-freebets-count">{activeCount}</span>
          <span className="my-freebets-pill-label">
            <FormattedMessage id="MY_FREEBETS_ACTIVE"/>
          </span>
        </Link>
        <Link to="/my-freebets/history" className="my-freebets-pill my-freebets-history">
          <span className="my-freebets-pill-label">
            <FormattedMessage id="MY_FREEBETS_HISTORY"/>
          </span>
          <span className="my-freebets-count">{historyCount}</span>
        </Link>
      </Box>
    </StyledMenu>
  );
}
